export * from './simple-layout.component';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/containers/simple-layout/index.ts